import graphql__463cd227944006b586bf from "./__generated__/EditPasswordMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import mapValues from "lodash/mapValues";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__463cd227944006b586bf;

function editPassword(form, resetPasswordToken, onCompleted) {
  const fieldsInput = mapValues(form.fields, field => field.value);
  const variables = { ...fieldsInput, resetPasswordToken };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { editPassword };
